import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { device } from "../styled";

const LocationContainer = styled.div`
  overflow-x: auto;
  display: flex;
  align-items: center;
  gap: 15%;
  height: 50px;
  background-color: #000;
  border-bottom: 2px rgba(255, 255, 255, 0.5) solid;
  padding: 0 20px;

  @media ${device.tablet} {
    gap: 10%;
    justify-content: center;
  }
`;

const City = styled.div`
  display: flex;
  gap: 5px;
  color: #fff;
  text-decoration: underline;
  text-decoration-color: #000;
`;

const Marker = styled.img`
  width: 15px;
`;

const Location = () => {
  return (
    <LocationContainer>
      <Link to={"/artist-barbershops/gyor"}>
        <City>
          <Marker src="/artist-scisor-marker.png" />
          Győr
        </City>
      </Link>
      <Link to={"/artist-barbershops/moson"}>
        <City>
          <Marker src="/artist-scisor-marker.png" />
          Mosonmagyaróvár
        </City>
      </Link>
      <Link to={"/artist-barbershops/csorna"}>
        <City>
          <Marker src="/artist-scisor-marker.png" />
          Csorna
        </City>
      </Link>
      <Link to={"/artist-barbershops/fertod"}>
        <City>
          <Marker src="/artist-scisor-marker.png" />
          Fertőd
        </City>
      </Link>
    </LocationContainer>
  );
};

export default Location;
